import { registryComponent } from '@boost-sd/components-registry/registry';
import { InnerHTMLRenderer } from '@components/InnerHTMLRenderer';

export type IntegrationProductLabelProps = {
  template?: string;
};

const IntegrationProductLabel = ({ template }: IntegrationProductLabelProps) => {
  if (!template) return null;

  return <InnerHTMLRenderer html={template} />;
};

export default registryComponent('IntegrationProductLabel', IntegrationProductLabel);
